import { render, staticRenderFns } from "./myHead.vue?vue&type=template&id=60be9c80&scoped=true"
import script from "./myHead.vue?vue&type=script&lang=js"
export * from "./myHead.vue?vue&type=script&lang=js"
import style0 from "./myHead.vue?vue&type=style&index=0&id=60be9c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be9c80",
  null
  
)

export default component.exports